<template>
  <div id="app" ref="App">
    <router-view />
    <Login></Login>
  </div>
</template>
<script>
import Login from '@/components/login.vue'
export default {
  components: { Login},
  
};
</script>
<style lang="scss">
  .tip7{
      background: rgba(183,0,8,0.12);
      height: 26px;
      min-width: 66px;
      text-align: center;
      border-radius: 4px;
      font-size: 14px;
      color: $mainBody-color;
      line-height: 26px;
  }
  .tip8{
      background: #f0f9eb;
      height: 26px;
      min-width: 66px;
      text-align: center;
      border-radius: 4px;
      font-size: 14px;
      color: #67c23a;
      line-height: 26px;
  }
  .tip1{
      background: #fdf6ec;
      height: 26px;
      min-width: 66px;
      text-align: center;
      border-radius: 4px;
      font-size: 14px;
      color: #e6a23c;
      line-height: 26px;
  }
  .tip2{
      background: #fdf6ec;
      height: 26px;
      min-width: 66px;
      text-align: center;
      border-radius: 4px;
      font-size: 14px;
      color: #e6a23c;
      line-height: 26px;
  }
</style>
<style lang="scss">
.el-table{
  color: #000928 !important;
}
.el-table__expand-icon{
  padding: 0 !important;
  color: #B80008 !important;
}
.tableHeader .el-icon-arrow-right::before {
  // font-family: iconfont;
  content: "" !important; /* 空内容，因为我们用背景图 */
  display: inline-block; /* 或者 block */
  width: 20px;
  height: 20px;
  background-image: url('./assets/111.png');
  background-size: contain; /* 或者 cover, 根据需要调整 */
  background-repeat: no-repeat;
  margin-top: -5px;

}

.el-table__expand-icon--expanded{
  transform:rotate(180deg) !important;
}
.whiteBox{
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
}
// 表格鼠标经过颜色
.el-table .el-table__body tr:hover > td {
  background-color: #F2F6FC !important; /* 你想要的颜色 */
}

.tableHeader th{
  background: #F2F6FC !important;
  font-size: 14px;
  color: #626783;
}
::v-deep .el-table--border {
	border-right: none !important;
	border-bottom: none !important;
}
.el-table--border{
  border-right: solid 1px #D5D9E3 !important;
  border-bottom: solid 1px #D5D9E3 !important;

}
.el-table--border,
.el-table--group,
.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf,
.el-table__footer-wrapper td.el-table__cell {
	border-color:  #D5D9E3 !important;
}
.textBlue{
  color: $text-blue
}
.mainColor{
  color:$mainBody-color !important
}
.Mainclick{
  color:$mainBody-color;
  cursor: pointer;
}
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  font-size: 16px;
  min-width: 1200px;
}
body{
  background: #F8F8F8;
}
/* 两行样式 */
.twoLine{
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}
/* 单行样式 */
.single-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
<style lang="scss" >
/* 可点击样式 */
.clickText{
  cursor: pointer;
  color: $text-blue 
}
::v-deep img{
    max-width:100%;
}
::v-deep video{width:100%;height:auto;}
</style>

<style lang="scss">

.el-dialog{
	.el-dialog__header{
		background: #F3F3F3;
		font-family: SourceHanSansCN, SourceHanSansCN;
		font-weight: bold;
		font-size: 20px;
		color: #001923;
		padding-top: 17px;
		padding-bottom: 17px;
	}
	.el-dialog__body{
		padding: 16px 20px;
	}
	.el-dialog__footer{
		border-top: 1px solid #E3E6F0;
	}
	.dialog-footer-btn{
		text-align: right;
		margin-top: 13px;
		height: 30px !important;
	}
}

.el-dialog__header{
  /* background: #F0F3FD; */
  background: #F3F3F3;
  font-size: 20px;
  font-weight: bold;
  color: #000D3D;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.el-dialog__footer{
  border-top: 1px solid #E3E6F0;
  text-align: right;
  width: 100%;
  padding: 10px 20px;
}

.el-dialog:not(.is-fullscreen) {
	margin-top: 6vh !important;
	border-radius: 8px;
	overflow: hidden;
}
</style>


<style lang="scss">
@import './assets/_variables.scss'
</style>
